import React from 'react'
import { useContext } from "react";
import { LanguageContext } from "../routes/LanguageContext";

const Terms = () => {
     const { lang } = useContext(LanguageContext);
  return (
    
       <div style={{ padding: "20px", lineHeight: "1.5" ,fontSize:"16px", background: "linear-gradient(90deg,#FE602F,#FE902F)",color:"white"}}>
      <h2 style={{fontWeight:"600",justifyContent:"center",alignItems:"center",display:"flex"}}>{lang=="eng" ? "Terms & Conditions" : "الشروط والأحكام"}</h2>
      <h4><ul><li>{lang=="eng" ? 'For Mobily Subscribers the service price is 3.45 Riyal daily (VAT Included)* VAT Tax was already paid with refill card for prepaid subscribers.and to unsubscribe send U 13 to 625827' :
      'بالنسبة لمشتركين موبايلي سعر الخدمة 3.45 ريال يوميا (شامل قيمة الضريبة المضافة).* تم تحصيل مبلغ الضريبة لعملاء مسبق الدفع عند عملية شحن الرصيد.ولإلغاء الاشتراك أرسل غ 13 إلى 625827'}</li></ul></h4>
    </div>
    
  )
}

export default Terms
